<style lang="less" scoped>
  // @import './MemberAddress.less';
  .member-address {
    width: 100%;
    padding-bottom: 100px;
    .footer-button {
      position: fixed;
      bottom: 0;
      width: 100%;
      background: white;
      padding: 17px 25px;
      box-sizing: border-box;
    }
    .address-item {
      padding: 10px 15px 0 15px;
      background-color: #fff;
      margin-top: 10px;
      color:#555;
      /deep/.el-button--text {
        color:#555;
      }
      .address-handle {
        align-items: center;
        border-top: 1px solid #eee;
        margin-top: 10px;
      }
    }
  }
</style>
<template>
  <div class="member-address flex col">
    <div class="address-item flex col" v-for="(memberAddress, index) of memberAddresses" :key="index" :style="{'padding-bottom': activity.isAddressFixed ? '10px' : 0 }">
      <div class="flex row flex-sb flex-cc" @click="selectAddress(memberAddress, index)">
        <div class="flex row">
          <span>{{ memberAddress.consignee }}</span>
          <span>{{ memberAddress.mobile }}</span>
        </div>
        <el-button v-if="!activity.isAddressFixed" type="text" @click.stop="edit(memberAddress)">编辑</el-button>
      </div>
      <span>{{memberAddress.region}} {{memberAddress.address}}</span>
      <div v-if="!activity.isAddressFixed" class="flex row address-handle">
        <el-button type="text" style="width:50%" @click="deleteMemberAddress(memberAddress)">删除</el-button>
        <span style="color: #eee">|</span>
        <el-button type="text" :style=" memberAddress.isDefault == 1 ? 'width:50%;color:blue' : 'width:50%'" @click="setMemberAddress(memberAddress)">{{ memberAddress.isDefault == 1 ? '当前默认地址' : '设为默认地址' }}</el-button>
      </div>
    </div>
    <div v-if="!activity.isAddressFixed" class="footer-button flex flex-all-center shadow">
      <el-button type="primary" style="width:100%;" @click="addAddress">新增收货地址</el-button>
    </div>
  </div>
  <!-- <div style="width:1100px;margin:0 auto;overflow-x:auto;">
    <el-card>
      <div slot="header">
        收货地址
      </div>
      <div class="member-address-info">
        <div class="member-address-title">
          收货地址:
        </div>
        <div class="member-address-list">
          <div class="member-address-item" v-for="(memberAddress, index) of memberAddresses" :key="index">
            <div class="member-address-consignee">{{memberAddress.consignee}}</div>
            <div class="member-address-address">{{memberAddress.region}}{{memberAddress.address}}</div>
            <div class="member-address-mobile">{{memberAddress.mobile}}</div>
            <div class="member-address-default">
              <el-checkbox  v-cloak v-show="memberAddress.isDefault != 1" v-model="memberAddress.isDefault == 1" @change="setMemberAddress(memberAddress)"></el-checkbox>
            </div>
            <div class="member-address-default-desc" :class="checkDefaultAddress(memberAddress) ? 'active' : ''">{{ memberAddress.isDefault == 1 ? '默认地址' : '设置默认'}}</div>
            <svg-icon class="member-address-edit" icon-class="edit" @click.native="updateMemberAddress(memberAddress)" />
            <svg-icon class="member-address-delete" @click.native="deleteMemberAddress(memberAddress)" icon-class="delete" />
          </div>
        </div>
      </div>
    </el-card>
    <el-card>
    <div slot="header">新增收货地址</div>
      <div class="member-add-address">
        <div class="member-add-address-form">
          <div class="form-container">
            <el-form label-width="80px" ref="addAddress" :model="addAddress"  :rules="rules">
              <el-form-item label="所在地区" prop="addRegionOptions">
                <el-cascader :options="options" v-model="addAddress.addRegionOptions" style="width: 100%" @change="handleAddChange"></el-cascader>
              </el-form-item>
              <el-form-item label="详细地址" prop="address">
                <el-input resize="none" type="textarea" :rows="3" placeholder="请输入详细地址信息，如街道、小区、门牌号等信息" v-model="addAddress.address"></el-input>
              </el-form-item>
              <div class="member-consignee-mobile">
                <el-form-item label="收货人" prop="consignee">
                  <el-input placeholder="请输入姓名" v-model="addAddress.consignee"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                  <el-input placeholder="请输入11手机号码" v-model="addAddress.mobile"></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <div class="member-add-address-submit">
          <el-checkbox-group v-model="addAddress.isDefault">
            <el-checkbox label="1" style="font-size: 14px;">设为默认</el-checkbox>
          </el-checkbox-group>
          <el-button type="primary" @click="saveAddAddress">
            保存地址
          </el-button>
        </div>
      </div>
    </el-card>

    <el-dialog title="编辑收货地址" :visible.sync="dialogFormVisible" :before-close="handleCloseFrom">
      <el-form label-width="80px" ref="editAddress" :model="editAddress"  :rules="rules">
        <div id="editAddress">
          <div class="left fl">
            <ul>
              <li>
                <span class="key fl">所在地区：</span>
                <div class="area fl" style="width: 500px;">
                  <el-form-item prop="editRegionOptions">
                    <el-cascader style="width: 440px;" size="large" :options="options" v-model="editAddress.editRegionOptions" @change="handleEditChange"></el-cascader>
                  </el-form-item>
                </div>
              </li>

              <li>
                <span class="key fl">详细地址：</span>
                <div class="area-detail fl">
                  <el-form-item prop="address">
                    <el-input style="width: 440px;" resize="none" type="textarea" :rows="3" placeholder="请输入详细地址信息，如街道、小区、门牌号等信息" v-model="editAddress.address"></el-input>
                  </el-form-item>
                </div>
              </li>

              <li style="margin-bottom: 0px;">
                <span class="key fl" style="letter-spacing: 4px;">收货人：</span>
                <div class="consign fl" >
                  <el-form-item prop="consignee">
                    <el-input style="width: 160px;" placeholder="请输入姓名" v-model="editAddress.consignee"></el-input>
                  </el-form-item>
                </div>

                <span class="key fl">手机号码：</span>
                <div class="consign fl">
                  <el-form-item prop="mobile">
                    <el-input style="width: 160px;" placeholder="请输入11手机号码" v-model="editAddress.mobile"></el-input>
                  </el-form-item>
                </div>
              </li>

            </ul>
          </div>
          <div class="right fl">
            <p class="set-default">
              <el-checkbox-group v-model="editAddress.isDefault">
                <el-checkbox label="1" style="font-size: 14px;">设为默认</el-checkbox>
              </el-checkbox-group>
            </p>
            <p class="submit">
              <span class="primary" @click="saveEditAddress">保存地址</span>
            </p>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div> -->
</template>

<script>
  import _ from 'lodash';
  import { regionData,TextToCode,CodeToText } from 'element-china-area-data'
  import { mapState } from 'vuex'
  import { Dialog } from 'vant';

  export default {
    name: 'MemberAddress',
    data() {
      //验证收货人手机号
      var checkMobile = (rule, value, callback) => {
        //手机号验证11为数字
        let reg = /^1\d{10}$/;
        if (value === '') {
          callback(new Error('请输入收货人的手机号'));
        } else if (!reg.test(value)) {
          callback(new Error('请输入收货人正确的手机号!'));
        } else {
          callback();
        }
      };
      return {
        memberAddresses: [],
        dialogFormVisible: false,
        options: regionData,
        editAddress:{
          editRegionOptions: [],
          address: '',
          consignee: '',
          mobile: '',
        },
        // addAddress: {
        //   addRegionOptions: [],
        //   address: '',
        //   consignee: '',
        //   mobile: '',
        // },
        rules: {
          addRegionOptions: { type: 'array', required: true, message: '请选择配送地区。', trigger: 'change' },
          address: this.$formHelper.requiredRuleFactory('请填写配送详细地址。'),
          consignee: this.$formHelper.requiredRuleFactory('请填写收货人。'),
          mobile: [{ validator: checkMobile, trigger: 'change' }],
        }
      }
    },
    methods: {
      addAddress() {
        this.$router.push({name:'member-address-add', params: {type: 'add'}});
      },
      edit(item) {
        console.log('132', item);
        sessionStorage.setItem('addressInfo', JSON.stringify(item))
        this.$router.push({name:'member-address-add', params: {type: 'edit'}});
      },
      selectAddress(item, index) {
        if (this.type != 'order') return
        this.$router.push({name:'order-confirm',  query: { addressId: item.id }});
      },
      /**
       * 关闭修改收货地址模态
       */
      handleCloseFrom(done) {
        this.dialogFormVisible = false
        this.editAddress = {}
        this.$refs.editAddress.resetFields()
      },

      /**
       * 保存收货地址
       */
      async saveAddAddress() {
        await this.$formHelper.promisedValidate(this.$refs.addAddress)
        this.addAddress.memberId = this.memberId;
        const result = await this.$store.dispatch('address/create', this.addAddress);
        this.$refs.addAddress.resetFields()
        this.addAddress = {}
        this.getMemberAddresses();
      },

      /**
       * 更新收货地址
       */
      async saveEditAddress() {
        await this.$formHelper.promisedValidate(this.$refs.editAddress)
        this.editAddress.memberId = this.memberId;
        const result = await this.$store.dispatch('address/update', this.editAddress);
        this.getMemberAddresses();
        this.handleCloseFrom()
      },

      /**
       * 获取收货地址配送地区名称
       * @param value
       */
      handleAddChange (value) {
        this.addAddress.region = CodeToText[value[0]] + ' ' + CodeToText[value[1]] + ' ' + CodeToText[value[2]];
      },

      /**
       * 获取收货地址配送地区名称
       * @param value
       */
      handleEditChange (value) {
        this.addAddress.region = CodeToText[value[0]] + ' ' + CodeToText[value[1]] + ' ' + CodeToText[value[2]];
      },

      /**
       * 获取收货地址配送地区代码
       * @param value
       */
      getAddressIds(value) {
        const regionNames = value.split(' ')
        let options = []
        options[0] = TextToCode[regionNames[0]].code
        options[1] = TextToCode[regionNames[0]][regionNames[1]].code
        options[2] = TextToCode[regionNames[0]][regionNames[1]][regionNames[2]].code
        this.editAddress.editRegionOptions = options
      },

      /**
       * 更新收货地址
       * @param address
       */
      updateMemberAddress(address) {
        this.editAddress = address;
        this.getAddressIds(address.region)
        this.dialogFormVisible = true;
      },

      /**
       * 验证是否是默认收货地址
       * @param address
       * @returns {boolean}
       */
      checkDefaultAddress(address) {
        if(parseInt(address.isDefault) === 0) {
          return false;
        }
        return true;
      },

      /**
       * 设置默认收货地址
       * @param address
       * @returns {Promise<void>}
       */
      async setMemberAddress(address) {
        if (Number(address.isDefault) === 1) return
        this.memberAddresses = await this.$store.dispatch('address/update', {id : address.id, 'isDefault' : 1});
        this.getMemberAddresses();
      },

      /**
       * 删除收货地址
       * @param address
       * @returns {Promise<void>}
       */
      async deleteMemberAddress(address) {
        // await this.confirm('是否确定删除此收货地址？')
        Dialog.confirm({
          // title: '标题',
          message: '是否确定删除此收货地址？',
        })
          .then(async() => {
            this.memberAddresses = await this.$store.dispatch('address/remove', address);
            this.getMemberAddresses();
          })
          .catch(() => {
            // on cancel
          });
        // this.memberAddresses = await this.$store.dispatch('address/remove', address);
        // this.getMemberAddresses();
      },

      /**
       * 获取收货地址列表
       * @returns {Promise<void>}
       */
      async getMemberAddresses() {
        this.memberAddresses = await this.$store.dispatch('address/collection', { sorts: { createdAt:'DESC' } , query: { activityId: this.activityId } , all: true  });
        this.memberAddresses = this.memberAddresses.collection
      },
    },
    mounted() {
      const { type } = this.$route.query
      this.type = type
      this.getMemberAddresses();
    },
    computed : {
      ...mapState('activity', {
        activity: state => state.activity,
        activityId: state => state.activityId,
      }),
      ...mapState('auth', {
        memberId: state => state.currentUser.id
      }),
    },
    watch : {

    }
  };
</script>


